import { Dialog, withStyles, Zoom  } from '@material-ui/core';
import { DialogHeader } from './components/index';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import Content from './DialogContent';
import { compose } from 'recompose';
import constants from '../constants';

const styles = (theme) => ({
  dialog: {
    boxSizing: 'border-box',
    borderRadius: '2px',
    backgroundColor: theme.ModalBGColor,
    boxShadow: '2px 2px 4px black',
    minWidth: 'calc(100% - 10px)',
    minHeight: 'calc(100% - 10px)',
    fontWeight: '600',
    zIndex: '1300'// Keeping it 1300 to show snackbar above this popup, z-index of snackbar: 1400
  },
  root: {
    zIndex: '1300'
  }
});

const ShowBestDriversDialog = ({ handleClose, classes, userData, ...others }) => {
  const { theme } = userData.userProfile || {};

  return (
    <Dialog
      open
      onClose={handleClose}
      classes={{ paper: classes.dialog, root: classes.root }}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: constants.RECOMMENDATION_DIALOG_TRANSITION_TIMEOUT }}
      className={theme}>
      <DialogHeader
        id="customized-dialog-title"
        title="Driver Recommendations"
        onClose={handleClose}
      />
      <Content {...others} handleClose={handleClose} />
    </Dialog>
  );
};

export default compose(withUserProfile, withStyles(styles))(ShowBestDriversDialog);
